import React, { ReactElement } from "react"
import { PhoneNumberCollectionModal } from "../account/PhoneNumberCollectionModal"
import { CarrotPlansGatedAccountContainer } from "../../carrot-plans/case-rate-renewals/CarrotPlansGatedAccountModal"
import { useGetCaseRateRenewalStatus } from "../../carrot-plans/case-rate-renewals/useQueryCaseRateRenewals"
import { useFlags } from "launchdarkly-react-client-sdk"
import { useCurrentUser } from "../../context/user/UserContext"
import { useUserRole } from "../../partner-access/hooks/usePartnerAccess"
import { getHasCrrModalTriggeredThisSession, updateHasCrrModalTriggeredThisSession } from "./utils/localStorageUtils"

export function AppLoginModalContainer(): ReactElement {
  const hasCrrModalTriggeredThisSession = getHasCrrModalTriggeredThisSession()
  const { phoneNumber, dismissedPhoneNumberFeatureModal } = useCurrentUser()
  const { showPhoneCollectionModal } = useFlags()
  const {
    isLoading: isCrrLoading,
    showAdvancedCheckInFeatures,
    shouldCrrModalRender,
    isCrrAdvancedCheckIn
  } = useGetCaseRateRenewalStatus()
  const { isPartnerAccessingAccount, isUserRoleLoading } = useUserRole()
  const isDataLoading = isCrrLoading || isUserRoleLoading

  const shouldRenderPhoneNumberModal =
    showPhoneCollectionModal &&
    !isPartnerAccessingAccount &&
    !shouldCrrModalRender &&
    !hasCrrModalTriggeredThisSession &&
    !dismissedPhoneNumberFeatureModal &&
    !phoneNumber

  if (!hasCrrModalTriggeredThisSession) {
    updateHasCrrModalTriggeredThisSession(shouldCrrModalRender)
  }

  if (isDataLoading) {
    return null
  }

  if (shouldCrrModalRender) {
    return (
      <CarrotPlansGatedAccountContainer
        shouldCrrModalRender={shouldCrrModalRender}
        showAdvancedCheckInFeatures={showAdvancedCheckInFeatures}
        isCrrAdvancedCheckIn={isCrrAdvancedCheckIn}
      />
    )
  }

  if (shouldRenderPhoneNumberModal) {
    return <PhoneNumberCollectionModal />
  }

  return null
}
